import { render, staticRenderFns } from "./WA2hs.vue?vue&type=template&id=7bc6daf8&"
import script from "./WA2hs.vue?vue&type=script&lang=js&"
export * from "./WA2hs.vue?vue&type=script&lang=js&"
import style0 from "./WA2hs.vue?vue&type=style&index=0&id=7bc6daf8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "general/lang/WidgetWA2hs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Freleases%2Ffront%2Ffront_131%2Fsrc%2Fgeneral%2Fcomponents%2FwidgetComponents%2FWA2hs.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports